export enum Roles {
  ADMINISTRATEUR = "administrateur",
  ASSOCIE = "associe",
  EXPERT_COMPTABLE = "expert_comptable",
  COLLABORATEUR = "collaborateur",
  NOTAIRE = "notaire",
  AUDITEUR = "auditeur",
}
